import {requestTypeCodes} from "@/utils/constants/hrrequest/requestTypeCodes";

export default [
    {
        id: requestTypeCodes.Estudiantes,
        icon: 'fas fa-user',
        name: 'rb-request',
        label: 'Estudiante',
        disclaimer: 'Es requerido añadir un estudiante para la solicitud.',
    },
    {
        id: requestTypeCodes.DosMasEstudiantes,
        icon: 'fas fa-user-friends',
        name: 'rb-request',
        label: 'Dos o más estudiantes',
        disclaimer: 'Es requerido seleccionar al menos dos estudiantes para la solicitud.',
    },
    {
        id: requestTypeCodes.Grupo,
        icon: 'fas fa-users',
        name: 'rb-request',
        label: 'Grupo',
        disclaimer: 'Es requerido seleccionar un grupo con la misma alternativa de ubicación para la solicitud.',
    },
];